import { toast } from '@/components/toast';

export interface OtpChannelFlags {
  bypass?: boolean;
  whatsappSent?: boolean;
  smsSent?: boolean;
}

export interface ShowOtpSendToastsOptions {
  verb?: string;
  action?: string;
  /** Channel actually requested; omit for legacy dual-send responses. */
  channel?: 'whatsapp' | 'sms';
}

export function showOtpSendToasts(
  { bypass, whatsappSent, smsSent }: OtpChannelFlags,
  {
    verb = 'enviado',
    action = 'enviar',
    channel,
  }: ShowOtpSendToastsOptions = {},
) {
  if (bypass) {
    toast({
      type: 'success',
      description: 'Modo de teste ativado.',
    });
    return;
  }

  // Single-channel send (current default): only report the requested channel,
  // so a WhatsApp-only send never surfaces a spurious SMS failure.
  if (channel === 'whatsapp') {
    toast(
      whatsappSent
        ? { type: 'success', description: `Código ${verb} para seu WhatsApp!` }
        : {
            type: 'error',
            description: `Não foi possível ${action} o código. Tente novamente.`,
          },
    );
    return;
  }

  if (channel === 'sms') {
    toast(
      smsSent
        ? { type: 'success', description: `Código ${verb} por SMS!` }
        : {
            type: 'error',
            description: `Não foi possível ${action} o código. Tente novamente.`,
          },
    );
    return;
  }

  // Legacy responses may omit channel flags entirely; keep the old optimistic copy.
  if (whatsappSent === undefined && smsSent === undefined) {
    toast({
      type: 'success',
      description: `Código ${verb} para seu WhatsApp e SMS!`,
    });
    return;
  }

  const wa = Boolean(whatsappSent);
  const sms = Boolean(smsSent);

  if (!wa && !sms) {
    toast({
      type: 'error',
      description: `Não foi possível ${action} o código. Tente novamente.`,
    });
    return;
  }

  if (wa && !sms) {
    toast({
      type: 'success',
      description: `Código ${verb} para seu WhatsApp!`,
    });
    toast({
      type: 'error',
      description: `Não foi possível ${action} o SMS.`,
    });
    return;
  }

  if (!wa && sms) {
    toast({
      type: 'error',
      description: `Não foi possível ${action} o WhatsApp.`,
    });
    toast({
      type: 'success',
      description: `Código ${verb} por SMS!`,
    });
    return;
  }

  toast({
    type: 'success',
    description: `Código ${verb} para seu WhatsApp e SMS!`,
  });
}
